import { type MutationHookOptions, useMutation } from "@apollo/client";
import { CreatePlatformMenuItemMutation } from "../graphql/mutations";
import type {
  CreatePlatformMenuItemMutationType,
  CreatePlatformMenuItemMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useCreatePlatformMenuItemMutation = (
  options?: MutationHookOptions<
    CreatePlatformMenuItemMutationType,
    CreatePlatformMenuItemMutationVariablesType
  >
) => {
  return useMutation<
    CreatePlatformMenuItemMutationType,
    CreatePlatformMenuItemMutationVariablesType
  >(CreatePlatformMenuItemMutation, options);
};
